import { render, staticRenderFns } from "./ExternalRequestDetails.vue?vue&type=template&id=5d843bd7&scoped=true"
import script from "./ExternalRequestDetails.vue?vue&type=script&lang=js"
export * from "./ExternalRequestDetails.vue?vue&type=script&lang=js"
import style0 from "./ExternalRequestDetails.vue?vue&type=style&index=0&id=5d843bd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d843bd7",
  null
  
)

export default component.exports